import React, { useEffect, useCallback, memo } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const PAGE_SIZE = 20;
const DEBOUNCE_DELAY = 300;

const InlineSearchUI = memo(
  ({ activeTabType, triggerSearch, isFetching, isLoading, reset, searchTerm, setSearchTerm, prevRef }) => {
    // Handle search input changes
    const handleSearch = useCallback(
      (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (!value) {
          reset?.();
        }
      },
      [setSearchTerm, reset]
    );

    const callSearchApi = useCallback(
      (searchTerm, activeTabType) => {
        if (searchTerm)
          triggerSearch({
            query: searchTerm,
            size: PAGE_SIZE,
            from: 0,
            searchType: 'workspaces',
            filterType: activeTabType === 'All' ? '' : activeTabType,
          });
      },
      [triggerSearch]
    );

    // Handle search and pagination
    useEffect(() => {
      const handler = setTimeout(() => {
        if (prevRef.current.searchTerm !== searchTerm.trim() || prevRef.current.type !== activeTabType) {
          callSearchApi(searchTerm.trim(), activeTabType);
          // Update the reference
          prevRef.current = {
            searchTerm: searchTerm.trim(),
            type: activeTabType,
            page: 1,
          };
        }
      }, DEBOUNCE_DELAY);

      return () => clearTimeout(handler);
    }, [searchTerm, activeTabType]);

    return (
      <div style={{ marginBottom: '16px' }}>
        <Input
          placeholder="Search workspaces..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={handleSearch}
          allowClear
          style={{ width: '100%' }}
          loading={isFetching || isLoading}
        />
      </div>
    );
  }
);

InlineSearchUI.displayName = 'InlineSearchUI';

export default InlineSearchUI;
